import React, { useMemo } from 'react';

import { useSortAndFilterConfigContext } from '../../../context/SortAndFilterConfigContext';
import ActiveIngredientFilterClass from '../../../filterFactory/ActiveIngredientFilter';
import { useTreatmentFilterUpdaterContext, useTreatmentFilterStateContext } from '../../context/TreatmentFilterContext';
import { useSortAndFilterTreatmentsContext } from '../../../context/SortAndFilterTreatmentsContext';
import { getActiveIngredientOptions } from '../../../../../../modules/sortAndFilter/helpers/filterOptions';
import useCachedStatistics from '../hooks/useCacheStatistics';

import FilterSection, { FilterHeadings } from '../FilterUi/FilterSection/FilterSection';
import FilterShowMore from '../FilterUi/FilterShowMore/FilterShowMore';
import FilterRadioOption from '../FilterUi/FilterRadioOption/FilterRadioOption';
import FilterLabel from '../FilterUi/FilterLabel/FilterLabel';

const FILTER_KEY = 'activeIngredient';

const ActiveIngredientFilter = () => {
    const { filters } = useTreatmentFilterStateContext();
    const { updateFilters, setLastFilterUpdated } = useTreatmentFilterUpdaterContext();
    const config = useSortAndFilterConfigContext();
    const treatments = useSortAndFilterTreatmentsContext();
    const statistics = useCachedStatistics(FILTER_KEY);

    const activeIngredientFilter = filters.get(FILTER_KEY) as ActiveIngredientFilterClass;

    const activeIngredients = useMemo(() => getActiveIngredientOptions(treatments, config), [treatments, config]);

    const displayLimit = Number.isInteger(config.filters.activeIngredient?.initialDisplayLimit)
        ? config.filters.activeIngredient!.initialDisplayLimit!
        : 5;

    if (activeIngredients.length === 0) {
        return null;
    }

    return (
        <FilterSection title={FilterHeadings.activeIngredient} numberSelected={activeIngredientFilter.keys.size} className="space-y-100">
            <FilterShowMore className="space-y-150" displayLimit={displayLimit}>
                {activeIngredients.map((ingredient) => {
                    const checked = activeIngredientFilter.keys.has(ingredient);
                    const statistic = statistics.find(({ key }) => key === ingredient)?.statistics.value || 0;

                    const handleChange = () => {
                        if (checked) {
                            activeIngredientFilter.keys.delete(ingredient);
                        } else {
                            activeIngredientFilter.keys.add(ingredient);
                        }
                        updateFilters();
                        setLastFilterUpdated(FILTER_KEY);
                    };

                    return (
                        <li key={ingredient}>
                            <FilterRadioOption checked={checked} onChange={handleChange} disabled={!statistic}>
                                <FilterLabel>{ingredient}</FilterLabel>
                            </FilterRadioOption>
                        </li>
                    );
                })}
            </FilterShowMore>
        </FilterSection>
    );
};

export default ActiveIngredientFilter;
